import React from 'react';
import classNames from 'classnames';
import { loaders } from '../utils/loaders';

import { NavLink, Outlet, useParams } from 'react-router-dom';
import Helmet from 'react-helmet';
import Loading from '../components/Loading.jsx';

export const useOrg = (netsuite_entity) => {
    const [inProgress, setInProgress] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    const [org, setOrg] = React.useState({
        name: {}
    });
    const [members, setMembers] = React.useState([]);
    React.useEffect(() => {
        (async () => {
            try {
                let orgResp = await loaders.org.load(netsuite_entity);
                let _members = await loaders.org_users.load(netsuite_entity);
                setOrg(orgResp);
                setMembers(_members);
                setInProgress(false);
            } catch (error) {
                setInProgress(false);
                setIsError(true);
                setOrg({
                    currency: 'USD'
                });
                setMembers([]);
            }
        })();
    }, [netsuite_entity]);

    return { org, members, inProgress, isError, setOrg, setIsError };
};

const OrgWrapper = () => {
    const params = useParams();
    const { org, inProgress } = useOrg(params.netsuite_entity);

    if (inProgress) {
        return <Loading />;
    }
    let name = org.name ? org.name.long : 'Unknown Org';
    return (
        <div className="js-customer">
            <Helmet title={name} />
            <nav className="sub-nav no-print">
                <NavLink
                    to={`/org/${org.id}`}
                    className={({ isActive }) => classNames('index', { active: isActive })}
                    end
                >
                    {name}
                </NavLink>
                <NavLink to={`/org/${org.id}/grids`} className={({ isActive }) => classNames({ active: isActive })}>
                    Grid Ordering
                </NavLink>
            </nav>

            <div className="container">
                <Outlet />
            </div>
        </div>
    );
};
export default OrgWrapper;
